/**
 * Централизованная конфигурация API
 * Определяет базовый URL для всех API запросов и изображений
 */

/**
 * Получает базовый URL API в зависимости от окружения
 * @returns Базовый URL для API
 */
export const getApiUrl = (): string => {
  // В production используем REACT_APP_PRODUCTION_API_URL, если она указана
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_PRODUCTION_API_URL) {
    return process.env.REACT_APP_PRODUCTION_API_URL;
  }
  // В остальных случаях используем REACT_APP_API_URL или дефолтное значение
  return process.env.REACT_APP_API_URL || 'http://localhost:3000';
};

/**
 * Базовый URL API
 * Используется для всех HTTP запросов и формирования URL изображений
 */
export const API_BASE_URL = getApiUrl();
